import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connectPackChannel } from "../../api/boardbacks.ws";
import apiClient from "../../api/apiClient";
import Button from "../../ui/Button";

export default function MeetingMode() {
  const { id } = useParams();
  const [presenterState, setPresenterState] = useState(null);
  const [follow, setFollow] = useState(true);
  const [presence, setPresence] = useState([]);
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    const ws = connectPackChannel(id, (msg) => {
      if (msg.event === "presenter_state" || msg.event === "meeting_started") {
        setPresenterState(msg);
      } else if (msg.event === "presence") {
        setPresence(msg.users || []);
      }
    });
    return () => ws.close();
  }, [id]);

  const startMeeting = async () => {
    const resp = await apiClient.post(`/boardbacks/${id}/meeting/start`);
    setSessionId(resp.data.id);
    setPresenterState(resp.data);
  };

  const endMeeting = async () => {
    if (!sessionId) return;
    await apiClient.post(`/boardbacks/meeting/${sessionId}/end`);
    setSessionId(null);
    setPresenterState(null);
  };

  const updateState = async (next) => {
    if (!sessionId) return;
    await apiClient.post(`/boardbacks/meeting/${sessionId}/state`, next);
  };

  return (
    <div>
      <h2>Meeting Mode</h2>
      <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
        <Button onClick={startMeeting} variant="primary">
          Start Meeting
        </Button>
        <Button onClick={endMeeting} variant="destructive">
          End Meeting
        </Button>
        <label>
          <input type="checkbox" checked={follow} onChange={(e) => setFollow(e.target.checked)} /> Follow presenter
        </label>
      </div>
      <div>Presenter state: {presenterState ? JSON.stringify(presenterState) : "-"}</div>
      <div>Presence: {presence.length ? presence.join(", ") : "n/a"}</div>
      {sessionId && (
        <div style={{ marginTop: 8, display: "flex", gap: 8 }}>
          <Button onClick={() => updateState({ page: (presenterState?.page || 0) + 1 })} variant="secondary">
            Next Page
          </Button>
        </div>
      )}
    </div>
  );
}
